import React, { useEffect, useState, useRef } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { getDatabase, ref, get } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Dropdown } from 'react-bootstrap';
import '../css/Header.css';
import Swal from "sweetalert2";
import { FaSignOutAlt } from "react-icons/fa";

function Header({ onMenuClick }) {
  const [userData, setUserData] = useState(null);
  const auth = getAuth();
  const db = getDatabase();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userRef = ref(db, `blackstone-users/${user.uid}`);
        try {
          const snapshot = await get(userRef);
          if (snapshot.exists()) {
            setUserData(snapshot.val());
          }
        } catch (error) {
          console.error('Error fetching user data in header:', error);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        navigate('/login');
      })
      .catch((error) => {
        console.error("Logout Error:", error);
      });
  };

  return (
    <header className="d-flex justify-content-between align-items-center px-3 py-2 bg-light shadow-md w-100 flex-wrap">
      {/* Left: Menu Button */}
      <div className="d-flex align-items-center mb-2 mb-md-0">
        <button className="btn me-2 gradient-btn" onClick={onMenuClick}>
          ☰
        </button>
      </div>

      {/* Right: Profile Dropdown */}
      <Dropdown align="end" className="ms-auto">
        <Dropdown.Toggle
          variant="light"
          id="dropdown-profile"
          className="d-flex align-items-center border-0 bg-transparent flex-nowrap"
          style={{ minWidth: '0' }}
        >
          <img
            src={userData?.profileImageURL || "/images/user-profile.png"}
            alt="Profile"
            className="rounded-circle me-2 flex-shrink-0"
            style={{ width: '40px', height: '40px', objectFit: 'cover' }}
          />
          <span
            className="fw-semibold text-truncate d-none d-sm-inline"
            style={{ maxWidth: '100px', marginRight: '10px' }}
          >
            {userData?.username || 'Loading...'}
          </span>
          {/* logout Icon */}
          <FaSignOutAlt size={25}
            className="text-primary cursor-pointer"
            onClick={(e) => {
              e.stopPropagation(); // prevent dropdown toggle
              handleLogout();
            }}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item href="/profile">My Profile</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </header>
  );
}

export default Header;
